import { isNil } from "ramda";

import { CATEGORY_ROW_MAX_LIMIT } from "enums/categories";
import { PAGE_MODULES } from "enums/pageModules";

const getModuleTypeKey = (module) => {
  if (isNil(module?.type)) throw new Error("Contentful module 'type' is required");

  if (module.type !== PAGE_MODULES.CATEGORY_ROW) return module.type;

  return `${module.type}-${module.style}`;
};

export const getModuleMaxLimit = (module) => {
  const moduleTypeKey = getModuleTypeKey(module);

  if (isNil(CATEGORY_ROW_MAX_LIMIT[moduleTypeKey])) {
    throw new Error(`Undefined max limit for module type key '${moduleTypeKey}'`);
  }

  return CATEGORY_ROW_MAX_LIMIT[moduleTypeKey];
};
